import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { supabase } from './supabaseClient';
import iconoApp from './assets/icono.png';

export default function LoginScreen() {
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const [showForgot, setShowForgot] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError] = useState('');
  const [resetSuccess, setResetSuccess] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await signIn(email, password);
    if (error) setError('Invalid email or password');
    setLoading(false);
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetLoading(true);
    setResetError('');
    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: 'https://app.windmanagerpro.com'
    });
    if (error) {
      setResetError('Failed to send reset email. Please check the address and try again.');
    } else {
      setResetSuccess(true);
    }
    setResetLoading(false);
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: '#f4f2ed'
    }}>
      <div style={{
        background: '#ffffff', border: '1px solid #d4d0c8',
        borderRadius: '12px', padding: '40px', width: '100%', maxWidth: '400px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <img src={iconoApp} alt="logo" style={{ width: '48px', marginBottom: '12px' }} />
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#1a1c1e' }}>
            Wind<span style={{ color: '#c96a10' }}>Manager</span> Pro
          </div>
          <div style={{ color: '#7a7a72', fontSize: '0.85rem', marginTop: '4px' }}>
            Field Operations
          </div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
              fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
              Email
            </label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required placeholder="manager@email.com"
              style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                fontSize: '0.9rem', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: '8px' }}>
            <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
              fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
              Password
            </label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required placeholder="••••••••"
              style={{ width: '100%', padding: '10px 12px', background: '#f4f2ed',
                border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                fontSize: '0.9rem', boxSizing: 'border-box' }}
            />
          </div>

          <div style={{ marginBottom: '24px', textAlign: 'right' }}>
            <button
              type="button"
              onClick={() => { setShowForgot(true); setResetError(''); setResetSuccess(false); }}
              style={{ background: 'none', border: 'none', color: '#c96a10',
                fontSize: '0.8rem', cursor: 'pointer', padding: 0 }}
            >
              Forgot password?
            </button>
          </div>

          {error && (
            <div style={{ color: '#c0392b', fontSize: '0.85rem',
              marginBottom: '16px', textAlign: 'center' }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            width: '100%', padding: '12px', background: '#c96a10',
            border: 'none', borderRadius: '6px', color: '#fff',
            fontSize: '0.95rem', fontWeight: 700, cursor: 'pointer'
          }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '0.9rem', color: '#7a7a72' }}>
          Don't have an account?{' '}
          <button
            onClick={() => navigate('/signup')}
            style={{ background: 'none', border: 'none', color: '#c96a10',
              fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer', padding: 0 }}
          >
            Sign Up
          </button>
        </div>

        {showForgot && (
          <div style={{ background: '#f4f2ed', border: '1px solid #d4d0c8',
            borderRadius: '8px', padding: '16px', marginTop: '20px' }}>
            {resetSuccess ? (
              <div style={{ color: '#2e7d32', fontSize: '0.85rem', textAlign: 'center' }}>
                Check your email for the reset link
              </div>
            ) : (
              <form onSubmit={handleResetPassword}>
                <label style={{ display: 'block', color: '#4a4a44', fontSize: '0.75rem',
                  fontWeight: 700, marginBottom: '6px', textTransform: 'uppercase' }}>
                  Reset email
                </label>
                <input
                  type="email" value={resetEmail}
                  onChange={e => setResetEmail(e.target.value)}
                  required placeholder="manager@email.com"
                  style={{ width: '100%', padding: '10px 12px', background: '#fff',
                    border: '1px solid #bbb8b0', borderRadius: '6px', color: '#1a1c1e',
                    fontSize: '0.9rem', boxSizing: 'border-box', marginBottom: '10px' }}
                />
                {resetError && (
                  <div style={{ color: '#c0392b', fontSize: '0.8rem', marginBottom: '8px' }}>
                    {resetError}
                  </div>
                )}
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button type="submit" disabled={resetLoading} style={{
                    flex: 1, padding: '9px', background: '#c96a10',
                    border: 'none', borderRadius: '6px', color: '#fff',
                    fontSize: '0.85rem', fontWeight: 700, cursor: 'pointer'
                  }}>
                    {resetLoading ? 'Sending...' : 'Send reset link'}
                  </button>
                  <button type="button" onClick={() => setShowForgot(false)} style={{
                    padding: '9px 14px', background: 'none',
                    border: '1px solid #bbb8b0', borderRadius: '6px', color: '#4a4a44',
                    fontSize: '0.85rem', cursor: 'pointer'
                  }}>
                    Cancel
                  </button>
                </div>
              </form>
            )}
          </div>
        )}
      </div>
    </div>
  );
}